import React, { useEffect, useState } from 'react';
import Inputmask from "inputmask";

import './css/input.css';
import { MaskedTextBoxComponent } from '@syncfusion/ej2-react-inputs';

function PhoneText(props) {
    const [value, setValue] = useState(props.value ? props.value : "");
    const [invalid, setInvalid] = useState(false);
    const [edited, setEdited] = useState(false);

    const _isValidValue = (v) => {
        if (v) {
            let returnValue = v;
            returnValue = returnValue.replace("(", "");
            returnValue = returnValue.replace(")", "");
            returnValue = returnValue.replace("-", "");
            returnValue = returnValue.replace(" ", "");
            return !isNaN(returnValue);
        }
        return true;
    };

    useEffect(() => {
        setValue(props.value);
    }, [props.value]);

    useEffect(() => {
        if (!props.disabled) {
            if (props.required) {
                if (edited || props.submited) {
                    if (!value || !_isValidValue(value)) {
                        setInvalid(true);
                    }
                    else {
                        setInvalid(false);
                    }
                }
                else {
                    setInvalid(false);
                }
                setEdited(false);
            }
            else {
                setInvalid(!_isValidValue(value));
            }
        }
        else {
            setInvalid(false);
        }
    }, [value, props.required, edited, props.submited, props.disabled]);

    useEffect(() => {
        var phoneInput = document.getElementById(props.id);
        var inputMask = new Inputmask("(999)999-9999");
        inputMask.mask(phoneInput);
    });

    const onChange = (e) => {
        props.onChange && props.onChange(e);
        setValue(e.target.value);
        setEdited(true);
    };

    return (
        <React.Fragment>
            {/* <MaskedTextBoxComponent mask="000-000-0000" placeholder="Phone" floatLabelType="Auto" name="phone" value={personalInfo.phone} onChange={e => updateFormData(e)} /> */}

            <MaskedTextBoxComponent
                // mask="000-000-0000"
                id={props.id}
                name={props.name}
                placeholder={`${props.placeholder ? props.placeholder : ""}`}
                floatLabelType="Auto"
                value={props.value ? props.value : ""}
                cssClass={`e-outline bg-white ${invalid && "e-error"}`}
                onChange={(e) => onChange(e)}
                disabled={props.disabled === true}
                formNoValidate={true}
                data-form={props.form ? props.form : ""}
                data-invalid={invalid}
                data-required={props.required ? props.required : false}
            />

            {
                invalid && <span className="error-label">
                    <i className="fa fa-exclamation-circle me-1" aria-hidden="true"></i>
                    {props.errorMessage ? props.errorMessage : "This field is required"}
                </span>
            }
        </React.Fragment>
    );
}

export default PhoneText;